export default __webpack_public_path__ + "static/dont-align-ebdf26aa26b48cfc25be6fb34bcd0031.png";